import { ChartsByLabel } from 'interfaces/performanceTest';
import { useEffect, useState } from 'react';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {
  buildVirtualUserPlots,
  commonXAxisProps,
  fillInTimeGaps,
} from './helpers';
import Loading from './Loading';
import TooltipContent from './TooltipContent';

interface Props {
  ticks: number[];
  charts: ChartsByLabel;
  loading: boolean;
}

interface DataPoint {
  timeStamp: number;
  virtualUsers: number;
}

const VirtualUsers: React.FC<Props> = ({ ticks, charts, loading }) => {
  const [overallDataPoints, setOverallDataPoints] = useState<DataPoint[]>([]);

  useEffect(() => {
    if (charts && charts['Overall']) {
      setOverallDataPoints(
        fillInTimeGaps<DataPoint>(
          buildVirtualUserPlots(charts['Overall']),
          (timeStamp) => ({ timeStamp, virtualUsers: 0 }),
          (timeStamp, existing) => ({
            timeStamp,
            virtualUsers: existing.virtualUsers,
          })
        )
      );
    }
  }, [charts]);

  return (
    <>
      <header className="pb-4 pl-3 border-b-2 border-gray-100">
        Virtual Users
      </header>
      <div className="h-44 my-5">
        <ResponsiveContainer width="100%" height="100%">
          {loading ? (
            <Loading />
          ) : (
            <BarChart
              width={500}
              height={400}
              data={overallDataPoints}
              margin={{
                top: 10,
                right: 30,
                left: 10,
                bottom: 10,
              }}
            >
              <XAxis {...commonXAxisProps} ticks={ticks} />
              <YAxis />
              <Tooltip content={TooltipContent} />
              <Bar dataKey="virtualUsers" fill="#304D63" />
            </BarChart>
          )}
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default VirtualUsers;
